import { useEffect, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import { useIsRobot } from './RobotContext';
import { getWindow } from './getWindow';

/**
 * Разбор user-agent отдельно от navigator: на сервере его неоткуда взять,
 * а роботу тип устройства нужен уже в SSR
 */
export const parseMobileUserAgent = (userAgent: string, maxTouchPoints?: number) => {
    const isIos =
        /iPad|iPhone|iPod/i.test(userAgent) || (/Mac/i.test(userAgent) && Boolean(maxTouchPoints));

    return {
        isMobile: /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || isIos,
        isIos,
    };
};

export const getIsMobile = () => {
    const navigator = getWindow()?.navigator;

    return parseMobileUserAgent(navigator?.userAgent || '', navigator?.maxTouchPoints);
};

/**
 * Используется для определения мобильной версии приложения.
 * Если вернул null, значит мы еще на сервере
 */
export const useIsMobile = () => {
    const { isRobot, isMobile: isRobotMobile } = useIsRobot();
    // робот не гидрирует, поэтому ему тип устройства приходит с сервера уже готовым
    const [isMobile, setIsMobile] = useState<boolean | null>(isRobot ? isRobotMobile : null);

    useEffect(() => {
        // у робота значение уже пришло с сервера, перепроверять нечего
        if (isRobot) {
            return;
        }

        setIsMobile(getIsMobile().isMobile);
    }, [isRobot]);

    return isMobile;
};

/**
 * Используется только когда тип адаптивного layout должен определиться до первого paint.
 */
export const useIsMobileSync = () => {
    const [isMobile, setIsMobile] = useState<boolean | null>(null);

    useIsomorphicLayoutEffect(() => {
        setIsMobile(getIsMobile().isMobile);
    }, []);

    return isMobile;
};
